import { DataTableColumn } from "mantine-datatable";
import { useMemo } from "react";

import NumberProgressSlider from "../../../../components/NumberProgressSlider.tsx";
import { TableData, TableRow } from "../../../../components/Table/types.ts";
import { toCurrencyPrice } from "../../../../utils/number.ts";
import { TradeInsuranceDashboardItem } from "../types.ts";

interface Props {
  data: TradeInsuranceDashboardItem[] | null | undefined;
}

export function useTradeInsuranceDashboardTableData({
  data,
}: Props): TableData {
  const columns: DataTableColumn<TableRow>[] = [
    {
      accessor: "insuranceName",
      title: "Insurance Name",
      sortable: true,
      width: "250px",
    },
    {
      accessor: "customerName",
      title: "Customer Name",
      sortable: true,
      width: "250px",
    },
    {
      accessor: "tradeInsuranceAmount",
      title: "Trade Insurance Amount",
      sortable: true,
    },
    {
      accessor: "totalLimitActive",
      title: "Total Limit Active",
      sortable: true,
    },
    {
      accessor: "totalLimitUtilization",
      title: "Total Limit Utilization",
      sortable: true,
    },
    {
      accessor: "totalGiroAmount",
      title: "Total Giro Amount",
      sortable: true,
    },
    {
      accessor: "tradeInsuranceVsTotalLimitActive",
      title: "Trade Insurance vs Total Limit Active",
      width: 500,
    },
    {
      accessor: "tradeInsuranceVsTotalLimitUtilization",
      title: "Trade Insurance vs Total Limit Utilization",
      width: 500,
    },
    {
      accessor: "transactionsNumber",
      title: "# of Transactions",
      sortable: true,
    },
  ];

  const rows = useMemo(() => {
    return data?.map((item) => {
      return {
        insuranceName: item.insuranceName,
        customerName: item.customerName,
        tradeInsuranceAmount: toCurrencyPrice(item.tradeInsuranceAmount),
        totalLimitActive: toCurrencyPrice(item.totalLimitActive),
        totalLimitUtilization: toCurrencyPrice(item.totalLimitUtilization),
        totalGiroAmount: toCurrencyPrice(item.totalGiroAmount),
        tradeInsuranceVsTotalLimitActive: (
          <NumberProgressSlider
            value1={item.tradeInsuranceAmount}
            value2={item.totalLimitActive}
          />
        ),
        tradeInsuranceVsTotalLimitUtilization: (
          <NumberProgressSlider
            value1={item.tradeInsuranceAmount}
            value2={item.totalLimitUtilization}
          />
        ),
        transactionsNumber: item.transactionsNumber,
      };
    });
  }, [data]);
  return [columns, rows];
}
